'use client';

import { c as _c } from "react/compiler-runtime";
import { TableNoResults } from '@morpho-org/ui-v6/server';
import { memo } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
import { getMarketsUrl } from '@/helpers/routing';
import DashboardBorrowPositionsFilters from '../components/DashboardBorrowPositionsFilters';
const DashboardBorrowPositionsEmptyState = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex min-h-[32px] w-[100%] justify-between"><DashboardBorrowPositionsFilters positionChainIds={[]} filters={{
        collateralAssetIdsFilter: [],
        loanAssetIdsFilter: [],
        chainIdsFilter: []
      }} disabled={true} /><div /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="gap-sm flex flex-col">{t0}<TableNoResults withBorder={true} withBackground={false} text="No active Borrow positions." height="96px" className="rounded-[20px]"><ButtonLink mode="internal" href={getMarketsUrl()} buttonProps={{
          label: "Browse markets"
        }} /></TableNoResults></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default memo(DashboardBorrowPositionsEmptyState);